import React from "react";
import cx from "classnames";
var UserPopover = function UserPopover(_ref) {
  var text = _ref.text,
    userNav = _ref.userNav,
    www = _ref.www,
    c = _ref.c;
  var nav = userNav.nav,
    memberName = userNav.memberName,
    unread = userNav.unread,
    isSeller = userNav.isSeller;
  if (nav) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: 'tc-top-nav-right-link'
    }, /*#__PURE__*/React.createElement("a", {
      className: 'tc-top-nav-logout',
      href: "".concat(www, "/user-logout.html"),
      onClick: function onClick() {
        localStorage.setItem("imLoginout", "".concat(new Date().getTime()));
        localStorage.removeItem("imLogin");
      }
    }, "\u767B\u51FA"), /*#__PURE__*/React.createElement("span", {
      className: 'tc-top-nav-member-name'
    }, memberName), /*#__PURE__*/React.createElement("a", {
      className: 'tc-top-nav-msg',
      href: "".concat(www, "/member-msg.html?flag=msg"),
      target: '_blank',
      rel: 'noreferrer'
    }, unread)), /*#__PURE__*/React.createElement("div", {
      className: 'tc-top-nav-right-popover nav-profile'
    }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("a", {
      href: "".concat(c, "/photoMember-index.html"),
      target: '_blank',
      rel: 'noreferrer'
    }, "\u65B0\u8ECA\u6703\u54E1\u4E2D\u5FC3")), /*#__PURE__*/React.createElement("span", {
      className: 'tc-top-nav-right-dividing'
    }), /*#__PURE__*/React.createElement("h3", {
      style: {
        marginTop: 20
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(www, "/member-index.html"),
      target: '_blank',
      rel: 'noreferrer'
    }, "\u4E2D\u53E4\u8ECA\u6703\u54E1\u4E2D\u5FC3")), nav.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      }, /*#__PURE__*/React.createElement("p", {
        className: 'nav-profile-title',
        style: {
          color: item.titleColor
        }
      }, item.title), /*#__PURE__*/React.createElement("div", {
        className: cx("nav-profile-row", {
          split: !isSeller
        })
      }, item.items.map(function (ii) {
        return /*#__PURE__*/React.createElement("a", {
          className: 'nav-profile-col',
          style: {
            color: ii.color
          },
          href: ii.link,
          key: ii.name,
          target: '_blank',
          rel: 'noreferrer'
        }, ii.name);
      })), !!isSeller && /*#__PURE__*/React.createElement("span", {
        className: 'tc-top-nav-right-dividing'
      }));
    }), !!isSeller && (/*#__PURE__*/React.createElement("div", {
      className: 'nav-profile-row'
    }, /*#__PURE__*/React.createElement("a", {
      className: 'nav-profile-col',
      style: {
        marginTop: 0
      },
      href: "".concat(www, "/member-index.html"),
      target: '_blank',
      rel: 'noreferrer'
    }, "\u66F4\u591A\u5167\u5BB9")))));
  }
  return /*#__PURE__*/React.createElement("a", {
    className: 'tc-top-nav-right-link',
    href: "".concat(www, "/user-signin.html")
  }, text || "登入/註冊");
};
export default UserPopover;